var Logger =
/** @class */
function () {
  function Logger(enableLogging) {
    this._isEnabled = enableLogging;
  }

  Logger.prototype.LogError = function (message, data) {
    if (this._isEnabled) {
      if (data !== undefined) {
        console.error("[ERROR] => " + message, data);
      } else {
        console.error("[ERROR] => " + message);
      }
    }
  };

  Logger.prototype.LogWarning = function (message, data) {
    if (this._isEnabled) {
      if (data !== undefined) {
        console.warn("[WARNING] => " + message, data);
      } else {
        console.warn("[WARNING] => " + message);
      }
    }
  };

  Logger.prototype.LogInfo = function (message, data) {
    if (this._isEnabled) {
      if (data !== undefined) {
        console.info("[INFO] => " + message, data);
      } else {
        console.info("[INFO] => " + message);
      }
    }
  };

  return Logger;
}();

export { Logger };